import type { Config } from '@/config/types.ts';

// 不要使用 commons中的方法，会产生循环依赖
function getCurrentTenantCode(): string {
  const pathname = window.location.pathname;
  return pathname.split('/').filter(Boolean)[0];
}

const config: Partial<Config> = {
  baseUrl: '/api',
  mobileBaseUrl: 'https://mcar-dev.chemt.cn',
  timeout: 60 * 1000,
  basename: getCurrentTenantCode(),
  wsPath: '/ws',
};

export default config;
